import { Component, EventEmitter, Input, Output } from "@angular/core";
import { RegistryItemSampleBoard } from "@app/strain/materials/models/registry-item-sample-board";

@Component({
    selector: 'app-sample-board-registry-item',
    templateUrl: './sample-board-registry-item.component.html',
    styleUrls: ['./sample-board-registry-item.component.scss']
})
export class SampleBoardRegistryItemComponent {
    @Input() item: RegistryItemSampleBoard;
    @Input() index: number;
    @Input() itemType: 'registry' | 'sampleBoard' = 'registry';
    @Output() openRegistry = new EventEmitter<RegistryItemSampleBoard>();

    get displayName(): string {
        if (this.itemType === 'sampleBoard') {
            return this.item?.sampleBoard?.name
                || (this.item?.sampleBoard?.id ? `#${this.item.sampleBoard.id}` : 'N/A');
        }

        return this.item?.registerItem?.name
            || this.item?.registerItem?.partNumber?.name
            || (this.item?.registerItem?.id ? `#${this.item.registerItem.id}` : 'N/A');
    }

    onOpenRegistry(event: MouseEvent): void {
        event.stopPropagation();
        this.openRegistry.emit(this.item);
    }
}
